import React from 'react'

// Components
import { FilesManager } from '../../../../../_components/FilesManager'

// Services
import { getInvoiceSupportingDocuments } from '../../../../../_services/invoices.service'

// Styles
import { S_InvoiceFilesModal } from './InvoiceFilesModal.styles'

export const InvoiceFilesModal = ({ invoiceId }) => {
  return (
    <S_InvoiceFilesModal>
      <FilesManager
        allowDelete={true}
        allowExpand={true}
        allowPagination={true}
        allowUpload={false}
        draggable={true}
        paginationRequest={(searchString) => {
          return getInvoiceSupportingDocuments(invoiceId, searchString).then((documentsData) => ({
            results: documentsData.supporting_documents,
            total_results: documentsData.count,
          }))
        }}
        title="Supporting Documents"
        viewType="slimgallery"
      />
    </S_InvoiceFilesModal>
  )
}
